export const BASE_IMG_URL = process.env.REACT_APP_IMAGE_URL;
export const BASE_UPLOADED_IMG_URL = process.env.REACT_APP_UPLOAD_IMAGE_URL;
export const BASE_CACHE_VER = process.env.REACT_APP_BASE_CACHE_VERSION;
export const BASE_URL = process.env.REACT_APP_API_URL;
export const BUILD_ENV = process.env.REACT_APP_ENV;

// Cloudflare Captcha
export const CAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

// Freshdesk
export const TOKEN_COOKIE = process.env.REACT_APP_TOKEN_COOKIE;
export const REFRESH_TOKEN_COOKIE = process.env.REACT_APP_REFRESH_TOKEN_COOKIE;
export const FRESHDESK_SUB_DOMAIN = 'aika-online';

export const FRESHDESK_REDIRECT_DOMAIN =
    process.env.REACT_APP_FRESHDESK_REDIRECT_DOMAIN;
export const FRESHDESK_LOGOUT_URL = process.env.REACT_APP_FRESHDESK_LOGOUT_URL;

// Timezone
export const GMT_TIMEZONE = process.env.REACT_APP_GMT_TIMEZONE;
